import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=872e85d4&"
import script from "./benefit.vue?vue&type=script&lang=js&"
export * from "./benefit.vue?vue&type=script&lang=js&"
import style0 from "./benefit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "benefit.vue"
export default component.exports